import React from 'react'
import urljoin from 'url-join'

import { ParentSlug } from 'src/apollo/onlineOrdering'

import Link from 'shared/components/common/link'

import { useDisplayPageContext } from '../../../DisplayPageContext'

const MAX_BREADCRUMBS = 4

const Breadcrumbs = ({
  name,
  parentSlugs
}: {
  name: string
  parentSlugs?: Array<ParentSlug> | null
}) => {
  const { breadcrumbBasePath, breadcrumbBaseName } = useDisplayPageContext()

  const crumbs = []

  // Add parent slugs as breadcrumbs
  parentSlugs?.forEach((parentSlug) => {
    crumbs.push({
      name: parentSlug.name,
      path: urljoin(breadcrumbBasePath || '', `/categories/${parentSlug.slug}`)
    })
  })

  crumbs.push({
    name,
    path: '' // the menu item breadcrumb isn't clickable
  })

  // Calculate total breadcrumbs (Home + crumbs)
  const totalBreadcrumbs = 1 + crumbs.length

  // Determine which crumbs to display
  let displayCrumbs = crumbs
  let showEllipsis = false

  if (totalBreadcrumbs > MAX_BREADCRUMBS) {
    // Show Home, ellipsis, and last (MAX_BREADCRUMBS - 1) breadcrumbs
    showEllipsis = true
    displayCrumbs = crumbs.slice(-(MAX_BREADCRUMBS - 1))
  }

  const numCrumbs = displayCrumbs.length
  const crumbNodes = displayCrumbs.map((crumb, i) => {
    const isLast = i === numCrumbs - 1
    return (
      <React.Fragment key={i}>
        <li className='crumb slash'>/</li>
        <li className='crumb'>
          {!isLast ? (
            <Link href={crumb.path} sameTab>
              {crumb.name}
            </Link>
          ) : (
            crumb.name
          )}
        </li>
      </React.Fragment>
    )
  })

  // Add ellipsis if needed (before the last 3 crumbs)
  if (showEllipsis) {
    crumbNodes.unshift(
      <React.Fragment key='ellipsis'>
        <li className='crumb slash'>/</li>
        <li className='crumb'>...</li>
      </React.Fragment>
    )
  }

  // prepend the crumbs with the "Home" text.
  crumbNodes.unshift(
    <li className='crumb' key={-1}>
      <Link href={breadcrumbBasePath} sameTab>
        {breadcrumbBaseName}
      </Link>
    </li>
  )

  return (
    <div className='breadcrumbs'>
      <ul>{crumbNodes}</ul>
    </div>
  )
}

export default Breadcrumbs
